import { defineStore } from 'pinia';

export const useCookieStore = defineStore('counter', {
    state: () => ({
        cartCount: 0,
        favCount: 0,
    }),
    getters: {
        getCartCount: state => state.cartCount,
        getFavCount: state => state.favCount,
    },
    actions: {
        initCartCount(value) {
            this.cartCount = value;
        },
        setCartCount(value) {
            this.cartCount = value;
        },
        initFavCount(value) {
            this.favCount = value;
        },
        setFavCount(value) {
            this.favCount = value;
        },
    },
});
